import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=8602b034&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=8602b034&prod&lang=scss&scoped=true"
import style1 from "./PageHeader.vue?vue&type=style&index=1&id=8602b034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8602b034",
  null
  
)

export default component.exports